/*
 *   Copyright (c) 2023
 *   All rights reserved.
 */
import React from "react";
import { ResponsiveHeatMap } from "@nivo/heatmap";
import PropTypes from "prop-types";

const defaultAxisBottom = {
  tickRotation: 0,
  legend: "",
  legendOffset: 36,
};

const defaultAxisLeft = {
  tickRotation: 0,
  legend: "",
  legendOffset: -118,
};

const defaultColors = {
  type: "quantize",
  scheme: "blues",
  divergeAt: 0.5,
  steps: 4,
};

const VmoHeatmap = ({
  data = [],
  margin = { top: 20, right: 10, bottom: 40, left: 125 },
  valueFormat,
  axisBottom: axisBottomObj = {},
  axisLeft: axisLeftObj = {},
  colors: colorsObj = {},
  enableLabels = true,
}) => {
  const axisBottom = { ...defaultAxisBottom, ...axisBottomObj };
  const axisLeft = { ...defaultAxisLeft, ...axisLeftObj };
  const colors = { ...defaultColors, ...colorsObj };

  return (
    <ResponsiveHeatMap
      data={data}
      margin={margin}
      valueFormat={valueFormat}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 0,
        tickRotation: axisBottom.tickRotation,
        legend: axisBottom.legend,
        legendPosition: "middle",
        legendOffset: axisBottom.legendOffset,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: axisLeft.tickRotation,
        legend: axisLeft.legend,
        legendPosition: "middle",
        legendOffset: axisLeft.legendOffset,
      }}
      colors={{
        type: colors.type,
        scheme: colors.scheme,
        divergeAt: colors.divergeAt,
        steps: colors.steps,
      }}
      emptyColor="#555555"
      enableLabels={enableLabels}
    />
  );
};

export default VmoHeatmap;

VmoHeatmap.prototypes = {
  data: PropTypes.array.isRequired,
  margin: PropTypes.shape({
    top: PropTypes.number,
    right: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number,
  }),
  valueFormat: PropTypes.string,
  axisBottom: {
    tickRotation: PropTypes.number,
    legend: PropTypes.string,
    legendOffset: PropTypes.number,
  },
  axisLeft: {
    tickRotation: PropTypes.number,
    legend: PropTypes.string,
    legendOffset: PropTypes.number,
  },
  colors: {
    type: PropTypes.oneOf(["sequential", "diverging", "quantize"]),
    scheme: PropTypes.string,
    divergeAt: PropTypes.number,
    steps: PropTypes.number,
  },
  enableLabels: PropTypes.bool,
};
